import { Controller } from '@hotwired/stimulus';

// Liste des lignes d'une lecture de DOE : le lien qui ouvre la fenêtre
// d'une ligne (a[data-row-link]) emporte le filtre affiché (?filter=), pour
// que la fenêtre circule parmi les lignes de ce filtre.
export default class extends Controller {
    static targets = ['filter'];

    carry(event) {
        const link = event.target.closest('a[data-row-link]');
        if (!link || !this.hasFilterTarget) return;

        const url = new URL(link.href);
        url.searchParams.set('filter', this.filterTarget.value);
        link.href = url.toString();
    }
}
